import { ButtonBase, Menu, MenuItem, SvgIcon } from '@mui/material';
import { Box, BoxProps } from '@mui/system';
import { map } from 'lodash';
import React, { ComponentType, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { locales, localesMap } from 'src/common/locales';
import { DropdownIcon, SolidDropdownIcon } from 'src/components/icons/icons';
import useStyles from './styles';

export const LangSwitcher: ComponentType<{ variant?: 'white' } & BoxProps> = ({
  variant,
  ...props
}) => {
  const { i18n } = useTranslation();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [lang, setLang] = useState(i18n.language);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    setLang(lang);
    setAnchorEl(null);
  };

  return (
    <Box className={classes.root} {...props}>
      <ButtonBase
        id="basic-button"
        aria-controls="basic-menu"
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        className={classes.button}
      >
        {localesMap[lang].shortName}
        {variant === 'white' ? (
          <DropdownIcon />
        ) : (
          <SvgIcon component={SolidDropdownIcon} viewBox="0 0 24 24" color="primary" />
        )}
      </ButtonBase>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        className={classes.dropdown}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {map(locales, (item) => (
          <MenuItem
            className={classes.dropdownItem}
            onClick={() => handleChangeLanguage(item)}
            key={item}
          >
            {localesMap[item].shortName}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};
